import type { AvailabilityStatus, TrafficType } from '@psp-aggregator/sdk';
import sdk from '@psp-aggregator/sdk';
import { keepPreviousData } from '@tanstack/react-query';

export interface UseCatalogOffersParams {
  countries?: string[];
  currencies?: string[];
  enabled?: boolean;
  integrationMethods?: string[];
  limit?: number;
  page?: number;
  providerIds?: string[];
  search?: string;
  sort?: 'newest' | 'oldest';
  statuses?: AvailabilityStatus[];
  trafficTypes?: TrafficType[];
}

export const useCatalogOffers = ({
  countries,
  currencies,
  enabled = true,
  integrationMethods,
  limit = 48,
  page = 1,
  providerIds,
  search,
  sort,
  statuses,
  trafficTypes,
}: UseCatalogOffersParams = {}) =>
  sdk.queries.useListCatalogOffers(
    page,
    limit,
    search,
    sort,
    statuses,
    providerIds,
    countries,
    currencies,
    trafficTypes,
    integrationMethods,
    { enabled, placeholderData: keepPreviousData },
  );

export const useCatalogFacets = () =>
  sdk.queries.useGetCatalogFacets(
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    { placeholderData: keepPreviousData },
  );
